export default __webpack_public_path__ + "static/media/mlodz7.87b27620.jpg";